export const POLICYPERMISSIONS = {
    FormPolicies: {
        Manage: {
            key: 'forms:manage',
            scope: {
                Organization: 'organization',
            },
        },
    },

    Task: {
        RemoveAttachmentRequirement: {
            key: 'task:remove_attachment_requirement',
            scope: {},
        },
    },

    // Task Activity Permissions
    TaskAction: {
        Edit: {
            key: 'task_action:edit',
            scope: {
                Own: 'own',
                All: 'all',
            },
        },
        Delete: {
            key: 'task_action:delete',
            scope: {
                Own: 'own',
                All: 'all',
            },
        },
    },

    // Ticket Permissions
    Ticket: {
        View: {
            key: 'ticket:view',
            scope: {
                close_ticket_btn: 'close_ticket_btn',
            },
        },
        Create: {
            key: 'ticket:create',
            scope: {},
        },
        Edit: {
            key: 'ticket:edit',
            scope: {},
        },
        Comment: {
            key: 'ticket:comment',
            scope: {},
        },
        Complete: {
            key: 'ticket:complete',
            scope: {},
        },
        Close: {
            key: 'ticket:close',
            scope: {
                close_ticket_btn: 'close_ticket_btn',
            },
        },
        Assign: {
            key: 'ticket:assign',
            scope: {},
        },
    },

    // Sprint Permissions
    Sprint: {
        ViewCurrent: {
            key: 'sprint:view_current',
            scope: {},
        },
        ViewHistory: {
            key: 'sprint:view_history',
            scope: {},
        },
        Create: {
            key: 'sprint:create',
            scope: {},
        },
        Edit: {
            key: 'sprint:edit',
            scope: {},
        },
        Close: {
            key: 'sprint:close',
            scope: {},
        },
        AssignTicket: {
            key: 'sprint:assign_ticket',
            scope: {},
        },
    },

    // Participant Permission
    Participant: {
        View: {
            key: 'participant:view',
            scope: {},
        },
        Create: {
            key: 'participant:create',
            scope: {},
        },
        Delete: {
            key: 'participant:delete',
            scope: {},
        },
        Edit: {
            key: 'participant:edit',
            scope: {},
        },
        DirectEdit: {
            key: 'participant:edit_directly',
            scope: {},
        },
        DirectEditPersonalInfo: {
            key: 'participant:edit_directly:personal_info',
            scope: {},
        },
        DirectEditDates: {
            key: 'participant:edit_directly:dates',
            scope: {},
        },
    },

    // Permission for Admin Request
    AdminRequest: {
        ApproveTaskReactivation: {
            key: 'admin_request:approve:task_reactivation',
            scope: {},
        },
        ApproveTimeOff: {
            key: 'admin_request:approve:time_off',
            scope: {},
        },
        ApproveTaskExtension: {
            key: 'admin_request:approve:task_extension',
            scope: {},
        },
        ApproveProfileChange: {
            key: 'admin_request:approve:profile_change',
            scope: {},
        },
        ApproveTaskDeletion: {
            key: 'admin_request:approve:task_deletion',
            scope: {},
        },

        ViewTaskReactivation: {
            key: 'admin_request:view:task_reactivation',
            scope: {},
        },
        ViewTaskDeletion: {
            key: 'admin_request:view:task_deletion',
            scope: {},
        },
        ViewProfileChange: {
            key: 'admin_request:view:profile_change',
            scope: {},
        },
        ViewTaskExtension: {
            key: 'admin_request:view:task_extension',
            scope: {},
        },
        ViewTimeOff: {
            key: 'admin_request:view:time_off',
            scope: {},
        },

        CreateTaskDeletion: {
            key: 'admin_request:create:task_deletion',
            scope: {},
        },
        CreateProfileChange: {
            key: 'admin_request:create:profile_change',
            scope: {},
        },
        CreateTaskExtension: {
            key: 'admin_request:create:task_extension',
            scope: {},
        },
        CreateTimeOff: {
            key: 'admin_request:create:time_off',
            scope: {},
        },
        CreateTaskReactivation: {
            key: 'admin_request:create:task_reactivation',
            scope: {},
        },
    },


    CaseFilePolicies: {
        View: {
            key: 'case_file:view',
            scope: {},
        },
        Download: {
            key: 'case_file:download',
            scope: {},
        },
        Delete: {
            key: 'case_file:delete',
            scope: {},
        },
    },

    EmployeeFilePolicies: {
        View: { key: 'employee_file:view', scope: {} },
        Upload: { key: 'employee_file:upload', scope: {} },
        Download: { key: 'employee_file:download', scope: {} },
        EditMetadata: { key: 'employee_file:edit_metadata', scope: {} },
        Delete: { key: 'employee_file:delete', scope: {} },
    },

    ChannelPolicies: {
        AdminView: { key: 'chat_channel:admin_view', scope: { All: 'all' } },
        AdminEdit: { key: 'chat_channel:admin_edit', scope: { All: 'all' } },
        Create: { key: 'chat_channel:create', scope: { All: 'all' } },
        ManageMembers: { key: 'chat_channel:manage_members', scope: { All: 'all' } },
        ManageMemberAccess: { key: 'chat_channel:manage_member_access', scope: { All: 'all' } },
        Archive: { key: 'chat_channel:archive', scope: { All: 'all' } },
    },

    BillingPolicies : {
       View: {
            key: 'billing:view',
            scope: {},
        },
       Edit: {
            key: 'billing:edit',
            scope: {},
        },
       Create: {
            key: 'billing:create',
            scope: {},
        },
    },

    // dashboard_widget
    DashboardWidgetPolicies: {
        Manage: {
            key: 'dashboard:manage',
            scope: {
                Organization: 'organization',
            },
        },
        View: {
            key: 'dashboard_widget:view',
             scope: {
                Task_Progress: 'Task_Progress',
                Count_CIR_Resource_Request_Sign_File_Review: 'Count_CIR_Resource_Request_Sign_File_Review',
                Task_Due: 'Task_Due',
                Trents_Anylytics: 'trends_&_analytics',
                Upcoming_Meetings: 'upcoming_meetings',
                Team_Tracker: 'Team_Tracker',
                Participant_Engagement_Risk: 'Participant_Engagement_Risk',
                Top_performers: 'Top_performers',
            },
        }
    },

    // Compliance Exclusions
    ExclusionPolicies: {
        CreateTaskExclusion: {
            key: 'task:createExclusion',
            scope: {},
        },
        EditTaskExclusion: {
            key: 'task:editExclusion',
            scope: {},
        },
        CreateParticipantExclusion: {
            key: 'participant:createExclusion',
            scope: {},
        },
        EditParticipantExclusion: {
            key: 'participant:editExclusion',
            scope: {},
        },
    },

    // Team Policies
    TeamPolicies: {
        View: {
            key: 'team:manage',
            scope: {},
        },
    },

    // Report Policies
    ReportPolicies: {
        View: {
            key: 'reports:view',
            scope: {},
        },
    },

    // Analytics Policies
    AnalyticsPolicies: {
        View: {
            key: 'analytics:view',
            scope: {},
        },
    },


} as const;
